import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, { "bg-color": "background" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        class: "pa-0 ma-0",
        "bg-color": "background",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "bg-color": "background" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                xxl: "9",
                xl: "9",
                lg: "9",
                md: "8",
                sm: "12",
                xs: "12",
                class: "align-right pt-8"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, "v" + _toDisplayString(_ctx.appVersionStr), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                xxl: "3",
                xl: "3",
                lg: "3",
                md: "4",
                sm: "12",
                xs: "12",
                class: "cr pt-9 pr-8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/oneshot",
                    title: "OneShot App",
                    class: "footer-nav-link"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("OneShot")
                    ])),
                    _: 1,
                    __: [0]
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mx-2" }, "|", -1)),
                  _createVNode(_component_router_link, {
                    to: "/privacy",
                    title: "User Terms & Conditions",
                    class: "footer-nav-link"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Terms")
                    ])),
                    _: 1,
                    __: [1]
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mx-2" }, "|", -1)),
                  _createVNode(_component_router_link, {
                    to: "/privacy",
                    title: "Privacy Policy",
                    class: "footer-nav-link"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Privacy Policy")
                    ])),
                    _: 1,
                    __: [2]
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mx-2" }, "|", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("a", {
                    href: "https://docs.missionsquad.ai",
                    target: "_blank",
                    rel: "noopener",
                    title: "Documentation",
                    class: "footer-nav-link"
                  }, "Docs", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mx-2" }, "|", -1)),
                  _cache[8] || (_cache[8] = _createTextVNode(" © Mission Squad 2026 "))
                ]),
                _: 1,
                __: [3,4,5,6,7,8]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}